import { render, staticRenderFns } from "./unrelated.vue?vue&type=template&id=27167133&scoped=true"
import script from "./unrelated.vue?vue&type=script&lang=js"
export * from "./unrelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27167133",
  null
  
)

export default component.exports